import { createReducer, on } from '@ngrx/store';
import * as ContractsByJobsiteActions from './contracts-by-jobsite.actions';
import { Contract } from 'src/app/pages/orders/interfaces/contracts.interface';

export interface ContractsByJobsiteState {
  response: Contract[] | null;
  error: any | null;
  loading: boolean;
  cache?: { [key: string]: Contract[] };
}

export const initialState: ContractsByJobsiteState = {
  response: null,
  error: null,
  loading: false,
  cache: {},
};

export const contractsByJobsiteReducer = createReducer(
  initialState,
  on(ContractsByJobsiteActions.loadContractsByJobsite, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(ContractsByJobsiteActions.loadContractsByJobsiteSuccess, (state, { response }) => ({
    ...state,
    loading: false,
    response,
    error: null,
  })),
  on(ContractsByJobsiteActions.loadContractsByJobsiteFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(ContractsByJobsiteActions.loadContractsByJobsiteSuccessByKey, (state, { key, response }) => ({
    ...state,
    loading: false,
    response,
    cache: { ...(state.cache || {}), [key]: response },
    error: null,
  })),
);
